import { BaseEnum, BaseEnumItem } from './baseEnum';

const SETTLE_TYPE = new BaseEnum();
SETTLE_TYPE.set('ARBITRARILY', new BaseEnumItem(1, '任意指定'));
SETTLE_TYPE.set('CASH_ON_DELIVERY', new BaseEnumItem(2, '货到付款'));

export { SETTLE_TYPE };